<template>
  <div class="container container-label">
    <router-link :to="item.path" class="label-title" v-for="(item,index) in title" :key="index">
      <span>{{item.list}}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: [
        { list: "培训", path: "/join" },
        { list: "加盟", path: "/join2" },
      ]
    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style lang='less' scoped>
.container-label {
  text-align: center;
  padding: 1rem 0;
  .label-title {
    color: #000;
    padding: 0 2rem;
    span {
      font-size: 1.2rem;
      font-weight: 500;
    }
  }
  .label-title.isActive {
    color: var(--color-active);
  }
}
</style>